import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { WorkoutService } from '../workout.service';
import { environment } from '../../../../../environments/environment';

@Component({
	selector: 'app-workout-list',
	templateUrl: './workout-list.component.html',
	styleUrls: ['./workout-list.component.scss']
})
export class WorkoutListComponent implements OnInit {
	@Input() selectionInfo: any;
	@Output() selectWorkOutListEventEmit: EventEmitter<any> = new EventEmitter<any>();
	workoutList: any;
	haloWebCloudURL: string = environment.haloWebCloudBasePath;
	savedGoalType: any;
	mylesTreadEquipment: any;
	consolesWithTitle = ["aquaman","superman","hal", "falco", "neo_se4"];
	constructor(
		private commonUtil: CommonUtil,
		private workoutService: WorkoutService) { }

	ngOnInit(): void {
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.selectionInfo && changes.selectionInfo.currentValue !== changes.selectionInfo.previousValue) {
			let selectionInfo = changes.selectionInfo.currentValue;
			if (selectionInfo.activityId && selectionInfo.categoryId && selectionInfo.consoleType && selectionInfo.multiFacilities) {
				this.loadWorkOutList();
			}
		}
	}

	loadWorkOutList() {
		this.workoutService.getWorkoutsByActivity(this.selectionInfo.activityId, this.selectionInfo.categoryId, this.selectionInfo.consoleType).subscribe(val => {
			this.workoutList = val.workoutList;
			if(this.consolesWithTitle.indexOf(this.selectionInfo.consoleType) > -1) {// Removing Interval, Watts and METs for aquaman.
				var workout_list = this.workoutList
				for(var i=0; workout_list.length > i; i++) {
					if(workout_list[i].workoutId == '1009' || workout_list[i].workoutId == '1010') { //1005 is Interval, 1009 is Watts and 1010 is METs - removed interval as per 2336
						this.workoutList.splice(i, 1);
						i--;
					}
					if(this.selectionInfo.activityId==18 || this.selectionInfo.activityId == 19){
						if(workout_list[i].workoutId == '1004' || workout_list[i].workoutId == '1007' || workout_list[i].workoutId == '1008') { //1004 is heartrate, 1007 is Aerobic and 1008 is Reverse - removed as per 2950
							this.workoutList.splice(i, 1);                                                                         
							i--;
						}
					}
					
				}
			}
		});
	}

	onSelectWorkOut(workoutInfo:any) {
		this.selectWorkOutListEventEmit.emit(workoutInfo);
	}
}
